import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  NON_SSO_LOGIN_API,
  MIDDLE_WARE_BASE_URL,
  NON_SSO_REVALIDATE_LOGIN_API,
  CHG_PWD_INT_API,
} from "../../../../utils/CONSTANTS";
import axios from "../../../../utils/axios";

let requestType: any = null;

// The validate envelope carries isRehire ("1"/"0") from the API. It may arrive already
// unwrapped on the payload, or nested as a JSON string in data.response depending on the
// middleware. Parse both defensively; default to not-a-rehire.
const parseIsRehire = (payload: any): boolean => {
  try {
    const raw = payload?.data?.response ?? payload;
    const obj = typeof raw === "string" ? JSON.parse(raw) : raw;
    return String(obj?.isRehire ?? payload?.isRehire ?? "0") === "1";
  } catch {
    return false;
  }
};

const initialState = {
  nonSSOStatus: null,
  nonSSOState: null,
  nonSSOReqType: "",
  accesstoken: null,
  refreshtoken: null,
  nonSSOMsg: "",
  isRehire: false,
};

export const nonSSOLogin = createAsyncThunk(
  "post/nonSSOLogin",
  async (data: any) => {
    let response = null;
    requestType = data.nonSSOReqType;
    try {
      if (requestType.type === "login") {
        response = await axios.postRequest(
          MIDDLE_WARE_BASE_URL() + NON_SSO_LOGIN_API(),
          data.input
        );
      }
      if (requestType.type === "ChgPwd") {
        response = await axios.postRequest(
          MIDDLE_WARE_BASE_URL() + CHG_PWD_INT_API(),
          data.input
        );
      }
      if (requestType.type === "validate") {
        response = await axios.postRequest(
          MIDDLE_WARE_BASE_URL() + NON_SSO_REVALIDATE_LOGIN_API(),
          data.input
        );
      }
      return response;
    } catch (error: any) {
      return error.response;
    }
  }
);

export const nonSSOLoginSlice = createSlice({
  name: "nonSSOLogin",
  initialState,
  reducers: {},
  extraReducers: (builder: any) =>
    builder
      .addCase(nonSSOLogin.pending, (state: any) => {
        state.nonSSOState = "pending";
      })
      .addCase(nonSSOLogin.fulfilled, (state: any, action: any) => {
        state.nonSSOState = "fulfilled";
        state.nonSSOStatus = "success";
        state.nonSSOReqType = requestType.type;
        state.nonSSOMsg = "";

      if (requestType.type === "login" || requestType.type === "ChgPwd") {
  if (action?.payload?.httpStatus !== 200) {
    state.nonSSOState = "failed";
    state.nonSSOStatus = "fail";
    state.nonSSOReqType = "";
    
    // Get the error message from API
    const apiErrorMessage = action?.payload?.data?.error || action?.payload?.error;
    
    // Handle different error scenarios
    if (apiErrorMessage && apiErrorMessage.includes("existing TTEC employee")) {
      // User has reached start date - should use SSO
      state.nonSSOMsg = apiErrorMessage;
    } else if (action?.payload?.httpStatus === 401) {
      state.nonSSOMsg = "Please login with SSO";
    } else {
      state.nonSSOMsg = "Invalid Email or Password";
    }
  } else if (requestType.type === "login") {
    // OTP-send (login) succeeded. The backend fulfills this via validateNewUserV2,
    // so the envelope already carries isRehire — capture it now so the OTP screen
    // (which renders next) can show the welcome-back state.
    state.isRehire = parseIsRehire(action?.payload);
  }
}
        if (requestType.type === "validate") {
          state.accesstoken = action?.payload?.accessToken;
          state.refreshtoken = action?.payload?.refreshToken;
          state.isRehire = parseIsRehire(action?.payload);

          if (
            action?.payload &&
            (action?.payload?.httpStatus === 400 || action?.payload?.status === 400)
          ) {
            state.nonSSOState = "failed";
            state.nonSSOStatus = "fail";
            const parsed = action?.payload?.data?.error || "Invalid OTP";
            state.nonSSOMsg = parsed;
          }
        }

        if (requestType.type === "login" && action?.payload === undefined) {
          state.nonSSOState = "failed";
          state.nonSSOStatus = "fail";
          state.nonSSOReqType = "";
          state.nonSSOMsg =
            "Unable to verify your credentials. Please try again";
        }
      })
      .addCase(nonSSOLogin.rejected, (state: any) => {
        state.nonSSOReqType = "Something went wrong";
        state.nonSSOState = "failed";
        state.nonSSOStatus = "fail";
      }),
});

export const selectNonSSOLoginDetails = (state: any) => state.nonSSOLogin || {};

export default nonSSOLoginSlice.reducer;
